<template>
	<div>
		<Header></Header>
		<!-- logo -->
		<div class="search">
			<div class="w search-box d-flex align-items-center">
				<div class="logo d-flex align-items-center">
					<span class="mylogo" @click="qyback()"><img class="search-img" :src="qycg_user.logo" alt /></span>
					<div class="shopconsed">结算</div>
				</div>
				<div class="search-c d-flex align-items-center">
					<div class="search-item search-item-active d-flex align-items-center">
						<div class="search-num search-num-active d-flex align-items-center justify-content-center">1</div>我的购物车
					</div>
					<div class="search-line search-line-active"></div>
					<div class="search-item search-item-active d-flex align-items-center">
						<div class="search-num search-num-active d-flex align-items-center justify-content-center">2</div>确认订单
					</div>
					<div class="search-line"></div>
					<div class="search-item d-flex align-items-center">
						<div class="search-num d-flex align-items-center justify-content-center">3</div>审核
					</div>
					<div class="search-line"></div>
					<div class="search-item d-flex align-items-center">
						<div class="search-num d-flex align-items-center justify-content-center">4</div>确认收货
					</div>
				</div>
			</div>
		</div>
		<div class="content">
			<div class="w">
				<!-- 地址 -->
				<div class="address">
					<div class="address-top d-flex align-items-center">收货信息</div>
					<div class="address-list d-flex flex-wrap">
						<div class="address-item d-flex flex-direction-column justify-content-between" v-for="(item,index) in address_list"
						 :key="index" :class="{address_active:address_id == item.id}" @click="selectAddress(item.id)">
							<div class="item-top d-flex align-items-center">
								<div class="top-city flex_1" :title="item.province+item.city+item.district">{{item.province}} {{item.city}} {{item.district}} {{item.detail}}</div>
								<div class="top-name">({{item.name}})</div>
								<div class="top-btn d-flex align-items-center justify-content-center" v-show="item.is_default == 1">默认</div>
							</div>
							<div class="address-conter">{{item.detail}} {{item.mobile}}</div>
							<div class="address-btn d-flex align-items-center">
							  <div class="delete" @click.stop="deleteAddress(index)">删除</div>
							  <div class="amend" @click.stop="changeAddress(index)">修改</div>
							  <div class="default" @click.stop="setUpDefault(index)">设为默认</div>
							</div>
						</div>
						<div class=" address-add d-flex align-items-center flex-direction-column justify-content-center" @click="addAddress()">
						  <div class="add-img">
						    <img class="img-default" src="../../../assets/images/adddress_add.png" alt  />
						  </div>
						  <div class="add-title">添加新地址</div>
						</div>
					</div>
				</div>
				<!-- 支付方式 -->
				<div class="pay">
					<div class="pay-title d-flex align-items-center">支付方式</div>
					<div class="pay-list d-flex flex-wrap">
						<div class="pay-item d-flex align-items-center justify-content-center pay_item" v-for="(item,index) in this.payWaylist" :key="index" >
							<div class="pay-img" @click="payTwoway(item.payment,index)"><img :src="item.icon" alt=""></div>
							<div class="pay-name"  @click="payTwoway(item.payment,index)">{{item.payment==1?"微信支付":item.payment==2 ?"工行支付":"支付宝支付"}}</div>
							<div class="pay-select" v-if="paymentStatus==index"><img src="../../../assets/images/brand.png" alt=""></div>
						</div>
					</div>
					<!-- <ul class="clearfloat">
								<li class="d-flex align-items-center justify-content-center" :class="{active: 0 == pay_index}" @click="payType(0)">
									<i><img src="../../../assets/images/ttshop_wxzf.png" alt=""></i>
									<span>微信支付</span>
								</li>
								</ul> -->
				</div>
					
				<!-- 商品信息 -->
				<div class="submitshop">
					<div class="shop-name d-flex align-items-center">商品信息</div>
					<div class="shop-title d-flex align-items-center">
						<div class="shop-title-item" style="width:35%">商品信息</div>
						<div class="shop-title-item d-flex justify-content-center" style="width:14%">规格</div>
						<div class="shop-title-item d-flex justify-content-center" style="width:24%">单价</div>
						<div class="shop-title-item d-flex justify-content-center" style="width:12%">数量</div>
						<div class="shop-title-item d-flex justify-content-end" style="width:15%">小计</div>
					</div>
					<div class="shop-store" v-for="(item, index) in goods_list" :key="index">
						<!-- <div class="shore-name d-flex align-items-center">
							{{item.name}}
							<div class="shore-img">
								<img class="img-default" :src="item.logo" alt />
							</div>
						</div> -->
						<div class="store-box">
							<!-- 普通商品 -->
							<div class="shop-item d-flex align-items-center" v-for="(itemGoods,goodindex) in item.goods_list" :key="goodindex">
								<div class="shop-details d-flex align-items-center" style="width:35%">
									<div class="shop-img">
										<img class="img-default" :src="itemGoods.goods_pic" alt v-show="itemGoods.goods_pic" />
										<img class="img-default" src="../../../assets/images/not_img.png" alt v-show="!itemGoods.goods_pic" />
									</div>
									<div class="shop-names">{{itemGoods.goods_name}}</div>
								</div>
								<div class="shop-size d-flex justify-content-center" style="width:14%">
									<div class="shop-size-box">
										<div v-for="(itemAttr,indexAttr) in itemGoods.attr_list" :key="indexAttr">{{itemAttr.attr_group_name}}：{{itemAttr.attr_name}}</div>
									</div>
								</div>
								<div class="shop-unpic d-flex justify-content-center" style="width:24%"> {{itemGoods.single_price}}</div>
								<div class="shop-num d-flex justify-content-center" style="width:12%">{{itemGoods.num}}</div>
								<div class="shop-subtotal d-flex justify-content-end" style="width:15%">{{itemGoods.price}}</div>
							</div>
							<div class="shop-rest d-flex flex-wrap" >
								<!-- <div class="rest-top" v-if="item.is_invoice"> -->
								<div class="rest-top">
									发票
									<div class="invoice">
										<div class="invoice-title d-flex align-items-start" @click="isInvoice(index)">
											<div class="invoice-select">
												<img src="../../../assets/images/select_checked.png" alt v-show="item.is_show_invoice" />
												<img src="../../../assets/images/select_unchecked.png" alt v-show="!item.is_show_invoice" />
											</div>开具发票
										</div>
										<div class="invoice-content" v-show="item.is_show_invoice">
											<div class="tab-list d-flex flex-wrap">
												<div class="tab-item d-flex align-items-center" v-for="(invoiceItem,invoiceIndex) in invoice_list" @click="selectInvoice(index,invoiceIndex,invoiceItem)"
												 :class="{invoice_active:item.checked_invoice_index == invoiceIndex}">
													<div class="tab-img d-flex align-items-center justify-content-center" v-show="invoiceItem.type == 1">个</div>
													<div class="tab-img d-flex align-items-center justify-content-center" v-show="invoiceItem.type == 2">企</div>
													<div>{{invoiceItem.header}}</div>
													<div class="tab-select" v-show="item.checked_invoice_index == invoiceIndex">
														<img src="../../../assets/images/brand.png" alt />
													</div>
												</div>
												<div class="tab-item d-flex align-items-center" @click="someInvoice()">更多</div>
											</div>
											<div class="invoice-type d-flex align-items-center">
												<div class="invoice-type-name">发票类型</div>
												<el-select v-model="choice_invoice_id" placeholder="请选择" >
													<el-option v-for="(invoiceTypeItem,index) in invoice_type_list" :key="index" :label="invoiceTypeItem.name"
													 :value="invoiceTypeItem.id" disabled></el-option>
												</el-select>
											</div>
											<div class="invoice-radio d-flex align-items-center">
												<div class="invoice-type-name">抬头类型</div>
												<div class="invoice-radio-box">
													<el-radio v-model="item.invoice_title_type" label="1" @change="changeInvoiceTitle(index)" disabled>个人或事业单位</el-radio>
													<el-radio v-model="item.invoice_title_type" label="2" @change="changeInvoiceTitle(index)"  disabled>企业</el-radio>
												</div>
											</div>
											<div class="invoice-hearder d-flex align-items-center">
												<div class="invoice-type-name">发票抬头</div>
												<el-input v-model="item.invoice_title" placeholder="填写抬头名称" @keyup.native="invoiceTxt(index)"  disabled></el-input>
											</div>
											<div class="invoice-hearder d-flex align-items-center" v-show="item.invoice_title_type == 2">
												<div class="invoice-type-name">税号</div>
												<el-input v-model="item.invoice_taxpayer"  disabled placeholder="纳税人识别号或社会统一征信代码" @keyup.native="invoiceTxt(index)"></el-input>
											</div>
										</div>
									</div>
								</div>
								<!-- <div class="rest-top"  v-if="!vr_type || vr_type == 0"> -->
								<div class="rest-top">
									<!-- 配送方式 -->
									<div class="send">
										<div class="send-title d-flex align-items-start">配送方式</div>
										<div class="send-list d-flex" >
											<div class="send-item d-flex align-items-center justify-content-center" v-for="(methodItem,methodIndex) in shopping_method"
											  @click="shoppingMethod(methodIndex)" :class="{send_active:shopping_method_index == methodIndex}">
												<div >{{methodItem}}</div>
												<div class="send-select" >
													<img src="../../../assets/images/brand.png" alt />
												</div>
											</div>
											<!-- <div class="send-item d-flex align-items-center justify-content-center send_active">
												<div>快递配送</div>
												<div class="send-select">
													<img class="img-default" src="../../../assets/images/brand.png" alt />
												</div>
											</div> -->
										</div>
										<div class="send-pic">
											<div v-show="address_id">运费：{{item.express_price}}</div>
											<div v-show="!address_id">请先选择收货地址</div>
										</div>
									</div>
								</div>
								<!-- 卖家留言 -->
								<div class="rest-top">
								<div class="leave">
									<div class="leave-title d-flex align-items-start">给卖家留言：</div>
									<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容" v-model="item.content"></el-input>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
				<!-- 结算信息 -->
				<div class="close">
					<div class="close-title">结算信息</div>
					<div class="close-box">
						<!-- 总计 -->
						<div class="aggregate d-flex justify-content-end">
							<div class="aggregate-l d-flex flex-direction-column align-items-end">
								<div class="aggregate-l-item">
									<span>{{order_goods_num}}</span>件商品 总计：
								</div>
								<div class="aggregate-l-item">运费(价格)：</div>
							</div>
							<div class="aggregate-r">
								<div class="aggregate-r-item">{{order_total_goods_price}}</div>
								<div class="aggregate-r-item">{{all_express_price}}</div>
							</div>
						</div>
					</div>
				</div>
				<!-- 底部提交 -->
				<div class="bottom d-flex flex-direction-column align-items-end">
					<div class="bottom-pic">
						应付价格：
						<span>{{order_total_price}}</span>
					</div>
					<template v-for="(item,index) in address_list" v-if="address_id == item.id">
						<div class="bottom-address">
							<span>寄送至：</span>{{item.province}} {{item.city}} {{item.district}} {{item.detail}}
						</div>
						<div class="bottom-person">
							<span>收货人：</span>{{item.name}} {{item.mobile}}
						</div>
					</template>
					<div class="bottom-btn d-flex align-items-center justify-content-center" @click="payNow">提交订单</div>
				</div>
			</div>
		</div>
		<!-- 添加地址弹窗 -->
		<div class="address-mask address-masked">
			<el-dialog title="新增收货信息" :visible.sync="addressVisible">
				<div class="address-mask-box d-flex justify-content-center">
					<div class="address-mask-l d-flex flex-direction-column align-items-end" >
						<div class="item-title">收货人：</div>
						<div class="item-title">手机：</div>
						<div class="item-title">所在地区：</div>
						<div class="item-title">详细地址：</div>
					</div>
					<div class="address-mask-r d-flex flex-direction-column">
						<el-input class="item-input" v-model="address_name" placeholder="姓名，如张航" ></el-input>
						<div class="hint d-flex align-items-center">
						    <template v-if="address_name_type">
								<div class="hint-img">
									<img class="img-default" src="../../../assets/images/hint_icon.png" alt />
								</div>
								收货人名称最少2位
							</template>
						</div>
						<el-input v-model="address_mobile" placeholder="请填写正确的11位手机号码" maxlength="11" ></el-input>
						<div class="hint d-flex align-items-center">
							<template v-if="address_mobile_type">
								<div class="hint-img">
								  <img class="img-default" src="../../../assets/images/hint_icon.png" alt />
								</div>
								请填写正确的手机号
							</template>
						</div>
						<el-cascader :options="district_list" :props="{ value: 'id', label: 'name', children: 'list' }" v-model="address_province"  @change="provinceChange" ></el-cascader>
						<div class="hint d-flex align-items-center">
						    <template v-if="address_province_type">
								<div class="hint-img">
								  <img class="img-default" src="../../../assets/images/hint_icon.png" alt />
								</div>
								请选择地区
						    </template>
						</div>
						<el-input v-model="address_detail" placeholder="街道、小区、楼牌号等" ></el-input>
						<div class="hint d-flex align-items-center">
							<template v-if="address_detail_type">
								<div class="hint-img">
								  <img class="img-default" src="../../../assets/images/hint_icon.png" alt />
								</div>
								请填写详细地址
							</template>
						</div>
						<div class="default d-flex align-items-center" @click="change_default" >
						    <div class="default-img">
								<img class="img-default" src="../../../assets/images/select_checked.png" alt v-show="address_is_default" />
								<img class="img-default" src="../../../assets/images/select_unchecked.png" alt v-show="!address_is_default" />
							</div>
							设为默认收货地址
						</div>
						<div class="address-btn d-flex align-items-center justify-content-center" @click="preserveAddress()" >
						  保存并使用
						</div>
				  </div>
				</div>
		    </el-dialog>
		</div>
		<!-- 发票信息 -->
		<div class="address-mask address-masked">
			<el-dialog title="发票信息" :visible.sync="addinfoVisible" >
			<Invoiceinfo  @closeA="closeA" @someInvoice="someInvoice"></Invoiceinfo>	
		  </el-dialog>
		</div>
		<!-- 支付弹层 -->
		<div class="ttshop_pay">
			<el-dialog title="" :visible.sync="pay_cont_type" >
				<div class="pay-title d-flex align-items-center justify-content-center">扫码支付¥{{order_total_price}}</div>
				<div class="pay-qrcode d-flex align-items-center justify-content-center">
					<div id="qrcode" ></div>
				</div>
			</el-dialog>
		</div>
		<div ref="alipayWap" v-html="alipay" />
	</div>
</template>

<script>
	import Header from "@/components/purchase/header/header";
	import Invoiceinfo from './Invoiceinfo'
	import QRCode from "qrcodejs2";
	import "./submitorder.css";
	let Base64 = require("js-base64").Base64;
	export default {
		components: {
			Header,
			Invoiceinfo
		},
		data() {
			return {
				paymentStatus:3,
				payWaylist:[],//支付方式
				pay_cont_type: false, //支付二维码弹层
				order_status_query: '', //查询订单状态计时器
				route_url: this.$store.state.route_url,
				qycg_user:this.$store.state.qycg_user.basics,
				mch_list: this.$store.state.qycg_submit_order_rarams.mch_list,
				addressVisible: false, // 地址弹框
				addinfoVisible:false,//发票地址
				address_id: '', // 选中地址id
				address_list: [], // 地址列表
				address_name: "", // 地址-用户名
				address_name_type: false,
				address_mobile: "", // 地址-手机号
				address_mobile_type: false,
				address_province: [], // 地址-省市区
				address_province_type: false,
				address_detail: "", // 地址-详细地址
				address_detail_type: false,
				address_is_default: 0, // 地址-是否设为默认地址
				district_list: [], // 地址省市区列表
				need_save_address_id: "", // 需要修改的地址id
				data: {
					pay_type_list: [{}],
				},
				payment_type: -1,
				payment:"",
				goods_list: [],  //商品列表
				order_goods_num: 0, //订单商品数量
				order_total_price: 0, //总价应付金额
				order_total_goods_price: 0, //商品总金额（裸价）
				all_express_price: this.$store.state.all_express_price, //总运费
				order_status_query: '', //查询订单状态计时器
				loading: '',
				store: {
					store: {}
				}, //商城配置，用户信息，热搜
				invoice_list: [],  //发票列表
				vr_type: this.$store.state.qycg_submit_order_rarams.vr_type,
				invoice_id :'' ,   //发票id
				invoice_type_list:[
					{
						id:'1',
						name:'增值税普通发票'
					},{
						id: '2',
						name: "增值税专用发票"
					}
				],
				choice_invoice_id:'',
				shopping_method: ['快递配送'],
				shopping_method_index: 0,
				alipay:"",
			};
		},
		created() {
			let that = this;
			if (sessionStorage.getItem('alipay_type')) {
				that.$confirm('订单已提交,请到订单中心查看', '温馨提示', {
					confirmButtonText: '查看订单',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					that.$router.replace({
						path: this.common.qycgrouter(this) + 'ordercenter',
						query: {}
					})
				}).catch(() => {
					that.$router.replace({
						path: this.common.qycgrouter(this) + 'ordercenter',
						query: {}
					})
				});
			}
			this.getData();
			this.getAddressList();
			// this.qycgInvoicelist();
			this.getDistrict();
			this.common.getCommonInfo(this);
			this.getpayWay()
		},
		methods: {
			closeA(item){	
				for(var i = 0;i<this.invoice_list.length;i++){
					if(this.invoice_list[i].id==item.id){
					var indexArry=i
					}
				}
				if(item==undefined || item==""|| item==null){
					this.addinfoVisible=false
				}else{
					this.addinfoVisible=false
					this.selectInvoice(0,indexArry,item)
				}			
			},
			// 获取省市区
			getDistrict() {
				let that = this;
				this.$api.addressData().then((res) => {
				    if (res.code == 0) {
						that.district_list = res.data;
					}
				}).catch((err) => {
			      console.log(err);
			    });
			},
			// 获取支付方式
			getpayWay() {
				let that = this;
				// console.log('this.$route.params', this.$route.params)
				let params = {
					shop_type: 'qycg',//business
				};
				this.$api.payWay(params).then((res) => {
				    if (res.code == 0) {
						this.payWaylist=res.list
					}
				}).catch((err) => {
			      console.log(err);
			    });
			},
			// 新增收货地址
			addAddress() {
				this.addressVisible = true;
				this.address_name = "";
				this.address_mobile = "";
				this.address_province = [];
				this.address_detail = "";
				this.address_is_default = 0;
			},
			// 保存地址
			preserveAddress() {
				let that = this;
				let address_name = this.address_name.trim();
				let address_mobile = this.address_mobile.trim();
				let address_province = this.address_province;
				let address_detail = this.address_detail.trim();
				this.address_name_type = false;
				this.address_mobile_type = false;
				this.address_province_type = false;
				this.address_detail_type = false;
				if (address_name.length < 2) {
					this.address_name_type = true;
					return false;
				} else if (!/^1[3456789]\d{9}$/.test(address_mobile)) {
					this.address_mobile_type = true;
					return false;
				} else if (!address_province.length) {
					this.address_province_type = true;
					return false;
				} else if (!address_detail) {
					this.address_detail_type = true;
					return false;
				}
				let params = {
					name: address_name,
					mobile: address_mobile,
					detail: address_detail,
					lng: "0",
					lat: "0",
					province_id: address_province[0],
					city_id: address_province[1],
					district_id: address_province[2],
					is_default: this.address_is_default,
					access_token: this.$store.state.qycg_user.access_token,
				};
				if (this.need_save_address_id) {
					params.address_id = this.need_save_address_id;
				}
				this.$api.addressSave(params).then((res) => {
					if (res.code == 0) {
						if (that.need_save_address_id) {
							that.need_save_address_id = "";
							that.$message({
								showClose: true,
								message: "修改成功",
								type: "success",
								offset: 200,
								duration: 1000,
							});
						} else {
							that.$message({
								showClose: true,
								message: "添加成功",
								type: "success",
								offset: 200,
								duration: 1000,
							});
						}
						that.getAddressList();
						that.addressVisible = false;
						that.address_name = "";
						that.address_mobile = "";
						that.address_province = [];
						that.address_detail = "";
						that.address_is_default = 0;
					}
				}).catch((err) => {
				  console.log(err);
				});
			},
			// 修改地址
			changeAddress(index) {
				let that = this;
				let address = this.address_list[index];
				this.address_name = address.name;
				this.address_mobile = address.mobile;
				this.address_province = [
					Number(address.province_id),
					Number(address.city_id),
					Number(address.district_id),
				];
				this.address_detail = address.detail;
				this.address_is_default = Number(address.is_default);
				this.need_save_address_id = address.id;
				this.addressVisible = true;
			},
			// 设为默认
			setUpDefault(index) {
				let that = this;
				let is_default = this.address_list[index].is_default;
				let params = {
					access_token: this.$store.state.qycg_user.access_token,
					address_id: this.address_list[index].id,
				};
				if (is_default != 1) {
					this.$api.addressDefault(params).then((res) => {
						if (res.code == 0) {
							that.getAddressList();
						}
					}).catch((err) => {
						console.log(err);
					});
				}
			},
			// 删除地址
			deleteAddress(index) {
				let that = this;
				let params = {
					access_token: this.$store.state.qycg_user.access_token,
					address_id: this.address_list[index].id,
				};
				this.$confirm("确认删除当前地址吗", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
					closeOnClickModal: false,
				})
			    .then(() => {
			      that.$api.addressDelete(params).then((res) => {
						if (res.code == 0) {
							that.address_list.splice(index, 1);
							that.$message({
								showClose: true,
								message: "删除成功",
								type: "success",
								offset: 200,
								duration: 1000,
							});
							let list = that.address_list;
							that.checkedAddress(list);
						}
			        }).catch((error) => {
			          console.log(error);
			        });
			    })
			    .catch(() => {});
			},
			// 选择省市区
			provinceChange(value) {
			  // console.log(value);
			},
			change_default() {
				this.address_is_default = this.address_is_default == 0 ? 1 : 0;
			},
			qyback(){
				this.$router.push({
					path: this.common.qycgrouter(this) + "/qycgindex",
				});
			},
			// 获取数据
			getData() {
				// this.$loading().close();
				let that = this;
				let params = {
					shop_type: 'qycg',
					address_id:this.address_id,
					access_token: this.$store.state.qycg_user.access_token,
					mch_list: that.mch_list,
					
				};
				this.$api.orderSubmissionPreview(params).then(res => {
					if (res.code == 0) {
						console.log(res)
						let goods_list = that.goods_list;
						for (let i in res.data.mch_list) {
							if (goods_list.length <= 0) {
								res.data.mch_list[i].offline = 0;
							}
							res.data.mch_list[i].source = 4; //来源
						}
						if (goods_list.length > 0) {
							for (let i in goods_list) {
								goods_list[i] = {
									...goods_list[i],
									...res.data.mch_list[i]
								};
							}
						} else {
							goods_list = res.data.mch_list
						}
						// console.log(goods_list);
						that.data = res.data;
						that.goods_list = goods_list;
							// console.log(goods_list);
						// 待修改
						for (let i in goods_list) {
							that.$set(that.goods_list, i, goods_list[i])
						}
						that.payment_type = res.data.pay_type_list.pay_type;
						that.computePrice();
					}
				}).catch(err => {
					// console.log(err);
				});
			},
			framewww(id){
				this.invoice_id = id;
				this.getData();
			},
			// 获取发票列表
			qycgInvoicelist() {
				// let qycgpay_type = this.$store.state.qycg_user.basics.pay_type;
				// if(qycgpay_type == 0){
				// 	this.dep_id = '';
				// }else{
				// 	this.dep_id = this.id;
				// }
				let dep_id = this.dep_i
				this.$api.qycgInvoice({
					shop_type: 'qycg',
					access_token: this.$store.state.qycg_user.access_token,
					dep_id: dep_id,
				}).then((res) => {
					this.invoice_list = res.data;
				}).catch((err) => {
					// console.log(err);
					this.invoice_list = [];
				});
			},
			// 获取地址列表
			getAddressList() {
				let dep_id = this.$store.state.qycg_user.department_id;
				this.$api.addressList({
					shop_type: 'qycg',
					access_token: this.$store.state.qycg_user.access_token,
					dep_id: dep_id,
				}).then(res => {
					if (res.code == 0) {
						// console.log(res)
						this.address_list = res.data;
						// console.log(1)
						this.checkedAddress(this.address_list );
					}
					// console.log(this.address_list)
				}).catch(err => {
					// console.log(err);
				});
			},
			// 地址默认选中
			checkedAddress(list) {
				let type = false;
				if (list && list.length) {
					for (let i in list) {
						if (list[i].is_default == 1) {
							this.address_id = list[i].id;
							type = true;
						}
					}
					if (type) {
						this.address_id = list[0].id;
						// console.log(this.address_id)
					}
					this.address_list = list;
				} else {
					this.address_id = '';
				}
			},
			// 设为默认
			// setUpDefault(index) {
			// 	let is_default = this.address_list[index].is_default;
			// 	let params = {
			// 		shop_type: 'qycg',
			// 		access_token: this.$store.state.qycg_user.access_token,
			// 		address_id: this.address_list[index].id
			// 	}
			// 	if (is_default != 1) {
			// 		this.$api.addressDefault(params).then(res => {
			// 			if (res.code == 0) {
			// 				this.getAddressList();
			// 			}
			// 		}).catch(err => {
			// 			console.log(err);
			// 		});
			// 	}
			// },
			// 地址选择
			selectAddress(id) {
				this.address_id = id;
				// console.log(this.address_id)
				this.getData();
			},
			
			// 计算价格
			computePrice() {
				let data = this.data;
				let mch_list = this.goods_list;
				let all_express_price = 0;
				// let all_express_price this.all_express_price;
				let order_total_price = 0;
				let order_total_goods_price = 0;
				let order_goods_num = 0;
				for (let i in mch_list) {
					let store_price = 0; //店铺总金额
					let store_goods_price = 0; //店铺商品总金额
					let parts_id = null;
					for (let j in mch_list[i].goods_list) {
						if (mch_list[i].goods_list[j].parts_id > 0) {
							if (parts_id != mch_list[i].goods_list[j].parts_id) {
								parts_id = mch_list[i].goods_list[j].parts_id;
								store_price += Number(mch_list[i].goods_list[j].parts_price)
								store_goods_price += Number(mch_list[i].goods_list[j].parts_price)
							}
						} else {
							if (mch_list[i].goods_list[j].is_level) {
								store_price += Number(mch_list[i].goods_list[j].level_price)
								store_goods_price += Number(mch_list[i].goods_list[j].level_price)
							} else {
								store_price += Number(mch_list[i].goods_list[j].price)
								store_goods_price += Number(mch_list[i].goods_list[j].price)
							}
						}
						order_goods_num += mch_list[i].goods_list[j].num
					}
					// 快递配送
					// console.log(this.address_id)   
					if (mch_list[i].offline == 0 && this.address_id) {
						store_price += Number(mch_list[i].express_price);
						all_express_price += Number(mch_list[i].express_price);
					}
					mch_list[i].total_price = store_price.toFixed(2);
					order_total_price += Number(store_price);
					order_total_goods_price += Number(store_goods_price);
				}
				
				
				this.goods_list = mch_list;
				this.order_total_price = order_total_price.toFixed(2); //应付金额
				this.order_goods_num = order_goods_num; //商品数量
				this.all_express_price = all_express_price; //总运费
				this.$store.commit("allExpressPrice", this.all_express_price);
				this.order_total_goods_price = order_total_goods_price; //商品总金额（裸价）
			},
			payTwoway(i,index){
				this.payment=i
				this.paymentStatus=index
			},

			// 提交订单
			payNow() {
				let that = this;
				let goods_list = that.goods_list;
				let vr_type = that.vr_type; //商品类型payment_type
				let payment_type = that.payment_type; //选中的支付方式
				// let payment = JSON.stringify([payment_type][0]);
				// 验证收货地址是否选择
				for (let i in goods_list) {
					if (!that.address_id) {
						that.$message({
							showClose: true,
							message: '请添加收货地址',
							type: 'warning',
							offset: 200,
							duration: 1000
						});
						return false;
					}
					// if (goods_list[i].is_show_invoice && !goods_list[i].invoice_id) {
					// 	that.addInvoice(i, function() {
					// 		that.payNow();
					// 	});
					// 	return false;
					// }
				}
				if(!this.payment){
					that.$message({
							showClose: true,
							message: '请选择支付方法',
							type: 'warning',
							offset: 200,
							duration: 1000
						});
						return false;
				}
				let params = {
					shop_type: 'qycg',
					access_token: this.$store.state.qycg_user.access_token,
					mch_list: JSON.stringify(goods_list),
					payment:this.payment,
				}
				if (that.address_id) {
					params.address_id = that.address_id;
				}
				if (that.invoice_id) {
					params.invoice_id = that.invoice_id;
				}
				// return false;
				// that.loading = this.$loading({
				// 	lock: true,
				// 	text: 'Loading',
				// 	spinner: 'el-icon-loading',
				// 	background: 'rgba(0, 0, 0, 0.3)'
				// });
				// console.log(params,"params")
				console.log(params,"hou")
				that.$api.orderSubmission(params).then(res => {
					if (res.code == 0) {
						// console.log(res)
						that.$message({
							showClose: true,
							message: '提交成功',
							type: 'warning',
							offset: 200,
							duration: 1000
						});
					}
					this.orderPay(res)
					// setTimeout(function(){
						// this.$router.replace(this.common.qycgrouter(this) + "/ordercenter");
					// },2000)
				}).catch(error => {
					// that.loading.close();
					that.$message({
						showClose: true,
						message: error.msg + '',
						type: 'warning',
						offset: 200,
						duration: 1000
					});
				});
			},
			//生成二维码
			qrcodeScan(url) {
				return new QRCode("qrcode", {
					width: 150, // 二维码宽度
					height: 150, // 二维码高度
					text: url,
					colorDark:"#000",
					colorLight:"#fff"
				});
			},
			//订单支付
			orderPay(e){
				this.$api.payData({
						shop_type: 'qycg',
						access_token: this.$store.state.qycg_user.access_token,
						pay_type:e.data.pay_type,
						order_id:e.data.order_id
				}).then(res=>{
					if(res.code==0){
						if(res.type=="WECHAT_PAY"){
							this.pay_cont_type = true;
							this.order_status_query = setInterval(() => {
							this.orderStatus(res.res.order_no);
						}, 5000);
						let url = Base64.decode(res.res.code_url);
						this.$nextTick(()=>{
							this.qrcodeScan(url);
						})
						}else if(res.type=="ALIPAY"){
							this.alipay = Base64.decode(res.data);
							// 防抖避免重复支付
							this.$nextTick(() => {
								// 提交支付表单
								this.$refs.alipayWap.children[0].submit();
								setTimeout(() => {
									this.orderStatus(res.res.order_no);
								}, 500);
							});
						}else {
							this.pay_cont_type = true;
							this.order_status_query = setInterval(() => {
								this.orderStatus(res.res.order_no);
							}, 5000);
							let url = Base64.decode(res.res.code_url);
							this.$nextTick(()=>{
								this.qrcodeScan(url);
							})
						}
						
					}else{
 							this.$message({
								type: 'info',
								message: res.msg
							});
						}
				})
			},
			//更多
			someInvoice(i){
				this.addinfoVisible=true
				this.getInvoiceList()
			},
			// 是否开发票
			isInvoice(index) {
				let goods_list = this.goods_list;
				// let choice_invoice = goods_list[index].choice_invoice;
				if (this.invoice_list.length == 0) {
					this.getInvoiceList();
				}else{
					this.getInvoiceList();
				}
				// let invoice_type_list = [];
				// for (let i in choice_invoice) {
				// 	if (choice_invoice[i] == 1) {
				// 		invoice_type_list.push({
				// 			id: 1,
				// 			name: "增值税普通发票"
				// 		});
				// 	} else if (choice_invoice[i] == 2) {
				// 		invoice_type_list.push({
				// 			id: 2,
				// 			name: "增值税专用发票"
				// 		});
				// 	}
				// }
				this.$set(goods_list[index], 'invoice_type_list', this.invoice_type_list); // 发票类型列表
				if (goods_list[index].is_show_invoice) {
					this.$set(goods_list[index], 'is_show_invoice', false); // 是否开发票
					this.$set(goods_list[index], 'choice_invoice_id', ''); // 选择的发票类型id
					this.$set(goods_list[index], 'invoice_id', ''); // 选择的发票类型id
				} else {
					this.$set(goods_list[index], 'is_show_invoice', true); // 是否开发票
					this.$set(goods_list[index], 'choice_invoice_id', 1); // 选择的发票类型id
				}
				
				this.goods_list = goods_list;
			},
			// 配送方式
			shoppingMethod(index) {
				// this.shopping_method_index = index;
				let goods_list = this.goods_list;
				goods_list[this.platform_index].offline = index;
				this.goods_list = goods_list;
				this.shopping_method_index = index;
				this.offline_store = index;
				// 判断如果是到店自提取消货到付款的选项
				if (index == 1) {
					let that = this;
					let pay_type_list = that.data.pay_type_list;
					let payment_type = that.payment_type;
					for (let i in pay_type_list) {
						if (pay_type_list[i].checked && pay_type_list[i].payment == 2) {
							pay_type_list[i].checked = false;
							payment_type = -1;
						}
					}
					that.data.pay_type_list = pay_type_list;
					that.data = that.data;
					that.payment_type = payment_type;
				}
				this.computePrice();
			},
			// 获取已有发票抬头列表
			getInvoiceList() {
				let that = this;
				this.$api.qycgInvoice({
					shop_type: 'qycg',
					access_token: this.$store.state.qycg_user.access_token,
				}).then(res => {
					if (res.code == 0) {
						that.invoice_list = res.data.list;
					}else{
						this.$message({
            message: res.msg,
            type: 'warning'
          })
					}
				}).catch(err => {
					// console.log(err);
				});
			},
			// 已有发票抬头选择---------------
			selectInvoice(index, invoice_index,data) {
				this.choice_invoice_id = String(data.type)
				let goods_list = this.goods_list;
				let invoice_list = this.invoice_list;
				this.$set(goods_list[index], 'checked_invoice_index', invoice_index); //选择发票抬头下标
				this.$set(goods_list[index], 'invoice_title_type', invoice_list[invoice_index].type); //发票抬头类型
				this.$set(goods_list[index], 'invoice_title', invoice_list[invoice_index].header); //发票抬头
				this.$set(goods_list[index], 'invoice_taxpayer', invoice_list[invoice_index].taxpayer); //税号
				this.$set(goods_list[index], 'invoice_id', invoice_list[invoice_index].id); //发票抬头id
				this.goods_list = goods_list;
			},
			// 发票抬头切换
			changeInvoiceTitle(index) {
				let goods_list = this.goods_list;
				this.$set(goods_list[index], 'checked_invoice_index', -1); //选择发票抬头下标
				this.$set(goods_list[index], 'invoice_id', ''); //发票抬头id
				this.goods_list = goods_list;
			},
			// 发票信息发生变动触发
			invoiceTxt(index) {
				let goods_list = this.goods_list;
				this.$set(goods_list[index], 'checked_invoice_index', -1); //选择发票抬头下标
				this.$set(goods_list[index], 'invoice_id', ''); //发票抬头id
				this.goods_list = goods_list;
			},
			
			//订单状态
			orderStatus(order) {
				let that = this;
				let params = {
					shop_type: 'qycg',
					access_token: this.$store.state.qycg_user.access_token,
					order_no: order,
				}
				this.$api.qycgorderStatus(params).then((res) => {
					if (res.code == 0) {
						clearInterval(that.order_status_query);
						that.$message({
							type: "success",
							message: '订单支付成功',
							showClose: true,
							offset: 200,
							duration: 1000,
						});
						setTimeout(() => {
							that.$router.replace({
								path: this.common.qycgrouter(this) +'/ordercenter',
								query: {}
							})
						}, 800)
					}
				}).catch((err) => {
					console.log(err)
				});
			},
	
		},
	};
</script>
<style lang="scss" scoped>
.ttshop_pay .pay-title{
    width: 100%;
    font-size: 14px;
    font-weight: 700;
		margin-bottom: 10px;
		.pay-qrcode {
    width: 200px;
    height: 200px;
}
}
	//添加地址弹窗
	.address-mask {
	  .address-mask-l {
	    width: 60px;
	    margin-right: 16px;
	
	    .item-title {
	      height: 28px;
	      line-height: 28px;
	      margin-bottom: 20px;
	    }
	  }
	
	  .address-mask-r {
	    .hint {
	      height: 20px;
	      color: #ff8500;
	
	      .hint-img {
	        height: 12px;
	        width: 12px;
	        margin-right: 8px;
	      }
	    }
	
	    .default {
	      .default-img {
	        height: 12px;
	        width: 12px;
	        margin-right: 4px;
	      }
	    }
	
	    .address-btn {
	      width: 108px;
	      height: 32px;
	      background: #ff0e25;
	      border-radius: 2px;
	      color: #fff;
	      margin-top: 38px;
	    }
	  }
	}
	.address-mask-box {
	  .default {
	    cursor: pointer;
	  }
	
	  .address-btn {
	    cursor: pointer;
	  }
	}
	.content {
		padding-bottom: 72px;
	}

	.pay_active {
		border-color: #ff0e25 !important;
	}

	.address_active {
		background-image: url(../../../assets/images/address_yes.png) !important;

		.top-city {
			color: #333333 !important;
		}

		.top-name {
			color: #333333 !important;
		}
	}

	// 发票选择样式
	.invoice_active {
		border-color: #ff0e25 !important;
		background: #fafafa !important;
	}

	// 配送方式选择样式
	.send_active {
		border-color: #ff0e25 !important;
		div {
			color: #ff0e25 !important;
		}
	}
	// logo
	.search {
		height: 112px;
		background-color: #fff;
		width: 100%;
		border-bottom: 1px solid #ebebeb;

		.search-box {
			height: 112px;

			.logo {
				.mylogo {
					display: block;
					width: 187px;
					height: 55px;
					cursor: pointer;
					.logo-img {
						width: 187px;
						height: 55px;
						// width: auto;
						// height: auto;
						// object-fit: fill;
						// display: block;
						// margin: 0 auto;
						// max-width: 100%;
						// max-height: 100%;
					}
				}

				.logo-line {
					width: 1px;
					height: 55px;
					background: #ebebeb;
					margin-left: 24px;
					margin-right: 20px;
				}

				.shopconsed {
					width: 140px;
					font-size: 20px;
					color: #666666;
					margin-left: 18px;
				}
			}

			.search-c {
				margin-left: auto;

				.search-item {
					color: #999999;

					.search-num {
						width: 24px;
						height: 24px;
						background: #ebebeb;
						border-radius: 24px;
						color: #999999;
						font-size: 14px;
						margin-right: 4px;
					}

					.search-num-active {
						color: #fff;
						background: #ff9010;
					}
				}

				.search-item-active {
					color: #ff9010;
				}

				.search-line {
					width: 60px;
					height: 2px;
					background: #ebebeb;
					margin: 0 8px;
				}

				.search-line-active {
					background: #ff9010;
				}
			}
		}
	}

	// 地址
	.address {
		border-bottom: 1px solid #e6e6e6;

		.address-top {
			height: 59px;
			font-size: 16px;
		}

		.address-list {
			.address-item {
				cursor: pointer;
				width: 274px;
				height: 126px;
				background-image: url(../../../assets/images/address_no.png);
				background-repeat: no-repeat;
				padding: 19px 16px;
				box-sizing: border-box;
				margin-right: 30px;
				margin-bottom: 32px;

				&:nth-child(4n) {
					margin-right: 0;
				}

				.item-top {
					.top-city {
						font-size: 16px;
						font-weight: 600;
						color: #999999;
						margin-right: 4px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}

					.top-name {
						color: #666666;
					}

					.top-btn {
						width: 40px;
						height: 20px;
						background: #ff9010;
						border-radius: 2px;
						color: #fff;
						margin-left: auto;
					}
				}

				.address-conter {
					width: 242px;
					height: 36px;
					font-size: 12px;
					color: #666666;
					line-height: 18px;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					overflow: hidden;
				}

				.address-btn {
					.delete {
					  color: #999999;
					}
					
					.amend {
					  color: #0e9cff;
					  margin-left: auto;
					}
					
					.default {
					  color: #0e9cff;
					  margin-left: 16px;
					}
				}
			}
		}
	}

	// 支付方式
	.pay {
		.pay-title {
			height: 72px;
			font-size: 16px;
		}

		.pay-list {
			.pay-item {
				position: relative;
				width: 158px;
				height: 40px;
				background: #ffffff;
				border-radius: 2px;
				border: 1px solid #ebebeb;
				margin-right: 20px;
				margin-bottom: 20px;
				cursor: pointer;

				&:hover{
				  border-color: #FF0E25;
				}
				.pay-img {
					height: 24px;
					width: 27px;
					margin-right: 8px;
				}

				.pay-name {
					color: #666666;
					font-size: 16px;
				}

				.pay-select {
					height: 12px;
					width: 12px;
					position: absolute;
					right: 0;
					bottom: 0;
				}
			}
		}
	}
// 支付方式
.rechargebut{
	.rechargebut-top{
		height: 40px;
			font-size: 16px;
	}
}
	// 商品信息
	.submitshop {
		.shop-name {
			height: 40px;
			font-size: 16px;
		}

		.shop-title {
			height: 40px;
			background-color: #fafafa;
			padding: 0 24px;
			box-sizing: border-box;
		}

		.shop-store {
			.shore-name {
				padding: 0 24px;
				box-sizing: border-box;
				height: 48px;
				font-weight: 600;

				.shore-img {
					height: 12px;
					width: 12px;
					margin-left: 4px;
				}
			}

			.store-box {
				background: #ffffff;
				border: 1px solid #ebebeb;
				padding: 0 24px;
				margin-top: 20px;
				box-sizing: border-box;

				.shop-item {
					padding: 20px 0;
					box-sizing: border-box;
					border-bottom: 1px solid #e6e6e6;

					.shop-details {
						.shop-img {
							height: 60px;
							width: 60px;
						}

						.shop-names {
							width: 230px;
							height: 36px;
							color: #666666;
							line-height: 18px;
							margin-left: 16px;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 2;
							overflow: hidden;
						}
					}

					.shop-size {
						.shop-size-box {
							width: 100%;

							div {
								color: #666666;
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
							}
						}
					}

					.shop-unpic {
						color: #666666;
					}

					.shop-num {
						color: #666666;
					}

					.shop-subtotal {
						font-weight: bold;
					}
				}

				.setmeal-box {
					.setmeal-title {
						margin-top: 20px;

						.setmeal-unpic {
							color: #666666;
						}

						.setmeal-num {
							color: #666666;
						}

						.setmeal-subtotal {
							font-weight: bold;
						}
					}

					.setmeal-list {
						.setmeal-item {
							padding: 20px 0;
							box-sizing: border-box;
							border-bottom: 1px dashed #e6e6e6;

							&:last-child {
								border-bottom: 1px solid #e6e6e6;
							}

							.shop-details {
								.shop-img {
									height: 60px;
									width: 60px;
								}

								.shop-names {
									width: 230px;
									height: 36px;
									color: #666666;
									line-height: 18px;
									margin-left: 16px;
									overflow: hidden;
								}
							}

							.shop-size {
								.shop-size-box {
									div {
										color: #666666;
									}
								}
							}

							.shop-unpic {
								color: #666666;
							}

							.shop-num {
								color: #666666;
							}

							.shop-subtotal {
								font-weight: bold;
							}
						}
					}
				}

				.shop-rest {
					.rest-top {
						width: 50%;
						border-bottom: 1px dashed #e6e6e6;
						box-sizing: border-box;

						&:nth-child(2n) {
							border-left: 1px dashed #e6e6e6;
						}

						&:nth-child(3) {
							border-bottom: 0;
						}

						&:nth-child(4) {
							border-bottom: 0;
						}
						
						// 发票
						.invoice {
							padding: 30px 30px 24px 20px;
							box-sizing: border-box;
						
							.invoice-title {
								height: 32px;
								line-height: 12px;
								margin-left: -20px;
								cursor: pointer;
						
								.invoice-select {
									height: 12px;
									width: 12px;
									margin-right: 8px;
								}
							}
						
							.invoice-content {
								// margin: 0 30px 20px 20px;
								background-color: #fafafa;
								padding: 16px;
								box-sizing: border-box;
						
								.tab-list {
									.tab-item {
										height: 32px;
										min-width: 82px;
										padding: 0 12px;
										box-sizing: border-box;
										background: #ffffff;
										border-radius: 2px;
										border: 1px solid #ebebeb;
										margin-right: 8px;
										position: relative;
										box-sizing: border-box;
										cursor: pointer;
										margin-bottom: 10px;
						
										.tab-img {
											width: 18px;
											height: 18px;
											background-color: #fff0f1;
											color: #ff3259;
											margin-right: 4px;
										}
						
										.tab-select {
											height: 12px;
											width: 12px;
											position: absolute;
											right: 0;
											bottom: 0;
										}
									}
								}
						
								.invoice-type {
									margin-top: 10px;
						
									.invoice-type-name {
										width: 48px;
										margin-right: 14px;
									}
								}
						
								.invoice-radio {
									margin-top: 20px;
						
									.invoice-type-name {
										width: 48px;
										margin-right: 14px;
									}
								}
						
								.invoice-hearder {
									margin-top: 20px;
						
									.invoice-type-name {
										width: 48px;
										margin-right: 14px;
									}
								}
							}
						}
						
						//配送
						.send {
							padding: 30px 0 24px 30px;
							box-sizing: border-box;

							.send-title {
								height: 32px;
								line-height: 12px;
								// margin-left: -20px;
							}

							.send-list {
								.send-item {
									height: 32px;
									width: 140px;
									box-sizing: border-box;
									background: #ffffff;
									border-radius: 2px;
									border: 1px solid #ebebeb;
									margin-right: 8px;
									position: relative;
									box-sizing: border-box;
									cursor: pointer;

									.send-select {
										height: 12px;
										width: 12px;
										position: absolute;
										right: 0;
										bottom: 0;
									}
								}
							}

							.send-pic {
								margin-top: 20px;
							}
						}

						.leave {
							padding: 30px 0 24px 30px;
							box-sizing: border-box;
						}
					}
				}
			}
		}
	}

	// 结算信息
	.close {
		.close-title {
			height: 64px;
			padding-top: 32px;
			box-sizing: border-box;
			font-size: 16px;
		}

		.close-box {
			border: 1px solid #ebebeb;
			padding: 24px 0;
			box-sizing: border-box;


			// 总计
			.aggregate {
				margin-top: 32px;
				padding-right: 36px;
				box-sizing: border-box;

				.aggregate-l {
					margin-right: 64px;

					.aggregate-l-item {
						+.aggregate-l-item {
							margin-top: 4px;
						}

						span {
							color: #ff0e25;
						}
					}
				}

				.aggregate-r {
					.aggregate-r-item {
						+.aggregate-r-item {
							margin-top: 4px;
						}
					}
				}
			}
		}
	}

	// 底部提交
	.bottom {
		margin-top: 32px;

		.bottom-pic {
			color: #666666;

			span {
				color: #ff4300;
				font-size: 22px;
			}
		}

		.bottom-address {
			margin-top: 12px;

			span {
				color: #666666;
			}
		}

		.bottom-person {
			span {
				color: #666666;
			}
		}

		.bottom-btn {
			width: 104px;
			height: 40px;
			background: #ff0e25;
			border-radius: 2px;
			color: #fff;
			font-size: 16px;
			margin-top: 12px;
			cursor: pointer;
		}
	}

	input::-webkit-input-placeholder {
		color: #999999;
	}

	

	.mailbox-box {
		padding-top: 32px;
		box-sizing: border-box;
		font-size: 16px;

		.title {
			float: left;
			font-size: 16px;
			line-height: 30px;
		}

		input {
			border: 1px solid #ebebeb;
			border-radius: 2px;
			padding: 0 10px;
			font-size: 14px;
			line-height: 30px;
			width: 240px;
		}
	}
	.address-add {
	  cursor: pointer;
	  width: 274px;
	  height: 126px;
	  background-image: url(../../../assets/images/address_no.png);
	  background-repeat: no-repeat;
	  margin-bottom: 32px;
	
	  .add-img {
	    height: 34px;
	    width: 34px;
	  }
	
	  .add-title {
	    color: #999999;
	    line-height: 12px;
	    margin-top: 8px;
	  }
	}
</style>
